export const routesEtkinlik = [
  {
    path: "/etkinlik",
    name: "etkinlik",
    component: () => import("@/views/etkinlik/index.vue"),
    meta: {
      public: false,
      title: "Etkinlik",
      yetki: { k: [1010002] },
    },
  },
]
